//create a functional component that renders a menu with a list of actions
import React from 'react';
//import { Link } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { CssBaseline, makeStyles } from '@material-ui/core';
import RouteConstants from '../../common/RouteConstants';
import LaunchIcon from '@material-ui/icons/Launch';


const useStyles = makeStyles((theme) => ({
    menuText: {
        color: theme.palette.background.paper,
        textDecoration: 'none',
        fontSize: '1rem',
        padding: '1rem',
        display: 'inline-flex',
        gap: 5,
        marginRight:'4px',
        '&:hover': {
            textDecoration: 'underline',
        }
    }
}
));

const PublicActionMenu = () => {
    const classes = useStyles();
    return (
        <ul className="menus">

            {/* <Link to={RouteConstants.PUBLIC_CURRICULUM} className={classes.menuText}>Curriculum</Link> */}
            <a href="https://makethecall.nba.com/" target="_blank" rel="noopener noreferrer" className={classes.menuText}>Make The Call <LaunchIcon style={{fontSize:'0.9rem'}}/></a>
        </ul>
    );
}

export default PublicActionMenu;